import React, { useState } from 'react';

import { Button, Form, Input, message, Typography, Upload } from 'antd';
import type { UploadFile } from 'antd/es/upload/interface';

import { PaperClipOutlined } from '@ant-design/icons';

import { api } from '../../http/API';

const { Title, Paragraph, Link, Text } = Typography;
const { TextArea } = Input;

interface FormValues {
    subject: string;
    message: string;
}

export const HelpPage = () => {
    const [form] = Form.useForm<FormValues>();
    const [sending, setSending] = useState(false);
    const [fileList, setFileList] = useState<UploadFile[]>([]);

    const submit = async (values: FormValues) => {
        setSending(true);
        try {
            const file = fileList[0]?.originFileObj as File | undefined;
            await api.SendSupportMessage(values.subject, values.message, file || null);
            message.success('Сообщение отправлено. Мы ответим на вашу почту.');
            form.resetFields();
            setFileList([]);
        } catch (e: any) {
            const msg = e?.response?.data?.message || 'Не удалось отправить сообщение';
            message.error(msg);
        } finally {
            setSending(false);
        }
    };

    return (
        <>
            <Typography style={{ fontSize: '1.05em' }}>
                <Title level={3} style={{ marginTop: 0 }}>
                    Нужна помощь?
                </Title>
                <Paragraph>
                    Многие вопросы по работе с платформой рассмотрены в{' '}
                    <Link href="https://agropogoda.com/static/files/manual.pdf" target="_blank">
                        руководстве пользователя
                    </Link>
                    .
                </Paragraph>
                <Paragraph>
                    О проблемах или предложениях напишите нам через форму ниже или на почту{' '}
                    <Link href="mailto:support@agropogoda.com">support@agropogoda.com</Link>.
                </Paragraph>
            </Typography>

            <div style={{ maxWidth: 640, marginTop: 24 }}>
                <Form form={form} layout="vertical" onFinish={submit}>
                    <Form.Item
                        label="Тема"
                        name="subject"
                        rules={[{ required: true, message: 'Укажите тему' }]}
                    >
                        <Input placeholder="Кратко о чём сообщение" size="large" />
                    </Form.Item>

                    <Form.Item
                        label="Описание"
                        name="message"
                        rules={[{ required: true, message: 'Опишите проблему или предложение' }]}
                    >
                        <TextArea
                            rows={6}
                            placeholder="Подробно опишите проблему или предложение. Если это ошибка — укажите, где и что делали."
                        />
                    </Form.Item>

                    <Form.Item label="Скриншот (опционально)">
                        <Upload
                            beforeUpload={() => false}
                            fileList={fileList}
                            onChange={({ fileList: list }) => setFileList(list.slice(-1))}
                            maxCount={1}
                            accept="image/*"
                        >
                            <Button icon={<PaperClipOutlined />}>Прикрепить файл</Button>
                        </Upload>
                        <Text type="secondary" style={{ fontSize: 12 }}>
                            Скриншот или изображение до 10 МБ.
                        </Text>
                    </Form.Item>

                    <Form.Item style={{ marginTop: 8 }}>
                        <Button type="primary" htmlType="submit" loading={sending} size="large">
                            Отправить
                        </Button>
                    </Form.Item>
                </Form>
            </div>
        </>
    );
};
